import React from 'react';
import { IoMdMailUnread } from 'react-icons/io';

export default function Booking() {
  const handleMailClick = () => {
    window.location.href = 'mailto:2002anuragksingh@gmail.com';
  };

  return (
    <div className="flex items-center justify-center bg-circle bg-no-repeat bg-right-top">
      <div className="flex w-[90%] md:px-20 flex-col md:flex-row mt-12 md:mt-52">
        {/* Left side */}
        <div className="w-full mt-32 lg:mt-0 md:w-1/2 p-4 mb-4 md:mb-24">
          <h1             data-aos="fade-right"
            data-aos-delay="500" className="text-3xl lg:text-orange font-bold mb-4">Contact For Our Services</h1>

          {/* First section on the left */}
          <div className="mb-4 mt-10 md:pr-16">
            <h2  data-aos="fade-right"
            data-aos-delay="600" className="text-xl font-semibold mb-2 ">Section Heading</h2>
            <p  data-aos="fade-right"
            data-aos-delay="700" className="text-gray-700">
              Sub Heading and Text goes here. This section will hold some text.
              Currently it is filled with some dummy text.
            </p>
          </div>
          <div className="flex flex-col mt-10">
            <div
               data-aos="fade-right"
               data-aos-delay="800"
              className="p-4 w-auto md:w-[400px] rounded-lg h-auto shadow-lg bg-orange-100 transition-transform transform hover:scale-105 mb-3"
              onClick={handleMailClick}
            >
              <div className="flex items-center w-full ">
                <IoMdMailUnread className="h-12 w-12 mr-3 text-gray-800" />

                <p className="font-bold text-gray-800"> Mail Us</p>
                <a className="flex-1 text-right text-gray-600">
                  2002anuragksingh@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Form */}
        <div  data-aos="fade-left"
            data-aos-delay="600" className="w-full md:w-1/2 p-4 mt-5 ">
          <form>

            {/* Name and Email inputs in the same line */}
            <div className="mb-4 flex flex-col md:flex-row">
              {/* Name input */}
              <div className="mb-4 md:mr-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-600"
                >
                  Name
                </label>
                <input
                  type="text"
                  placeholder='Full Name'
                  id="name"
                  name="name"
                  className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                />
              </div>

              {/* Email input */}
              <div className="mb-4 md:mb-0">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-600"
                >
                  Email
                </label>
                <input
                  type="email"
                  placeholder='xyz@gmail.com'
                  id="email"
                  name="email"
                  className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                />
              </div>
            </div>

            {/* Message input */}
            <div className="mb-4">
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-600"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                placeholder='I am really interested in your...'
                rows="4"
                className="mt-1 p-2 border border-gray-300 rounded-md w-full"
              ></textarea>
            </div>

            {/* Submit button */}
            <button
              type="submit"
              className="bg-orange text-white p-2 px-4 rounded-md "
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
